import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAuth(data);
    } catch {
      setAuth(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hd_token", data.token);
    await reload();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("hd_token");
    setAuth(false);
  };

  const group = auth ? auth.groups?.[0] : null;
  return (
    <AuthCtx.Provider value={{ auth, person: auth?.person, group, gid: group?.id, login, logout, reload }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function useMembers() {
  const { gid } = useAuth();
  const [data, setData] = useState({ kartas: [], members: [] });
  const load = useCallback(async () => {
    if (!gid) return;
    const r = await api.get(`/groups/${gid}/members`);
    setData(r.data);
  }, [gid]);
  useEffect(() => {
    load();
  }, [load]);
  return { ...data, reload: load };
}
